import { Component, ElementRef, ViewChild } from '@angular/core';
import { AbstractBlModal, ModalButtonType } from '@blcloud/bl-ng-ui-component';

/**
 * Yahoo公開鍵警告モーダルコンポーネント
 */
@Component({
  templateUrl: 'yahoo-publickey-warn-modal.component.html',
  styleUrls: ['./yahoo-publickey-warn-modal.component.scss'],
})
export class YahooPublicKeyWarnModalComponent extends AbstractBlModal {

  readonly title = '警告';

  /**  フッタボタンタイプ */
  footerButtonType = ModalButtonType.Custom;

  /** OKボタン */
  @ViewChild('okBtn') okBtn: ElementRef;

  /** その他ボタンのツールチップテキスト */
  anyButtonTooltip = 'BLNaviへの登録が必要です';

  /**
   * @override
   */
  getResults(): any {
    return {};
  }

  /**
   * @override
   */
  onShown() {
    this.okBtn.nativeElement.focus();
  }

  /**
   * キャンセル押下時
   */
  onClickCancel() {
    this.content.cancel();
  }

  /**
   * その他押下時
   */
  onClickAny() {
    this.content.any();
  }

  /**
   * 決定押下時
   */
  onClickDone() {
    this.content.done();
  }
}



// WEBPACK FOOTER //
// ./src/app/page/biz-menu-page/yahoo-publickey-warn-modal/yahoo-publickey-warn-modal.component.ts